var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZeroloopPortfolioCoverV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 690 430",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "Cover ilustrativo de ZeroLoop Job Hunter") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Ilustraci\xF3n mostrando una tarjeta de oferta laboral de LinkedIn a la izquierda, un rayo de an\xE1lisis en el centro, y un panel de resultados con porcentaje de match a la derecha, representando el flujo del producto"), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4338CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#312E81"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow2",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A5B4FC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A5B4FC",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 420,
    fill: "url(#bgGrad2)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 210,
    r: 190,
    fill: "url(#glow2)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.55,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 50,
    r: 2.5,
    fill: "#C7D2FE",
    style: {
      fill: "rgb(199, 210, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 70,
    r: 2.5,
    fill: "#C7D2FE",
    style: {
      fill: "rgb(199, 210, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 370,
    r: 2.5,
    fill: "#C7D2FE",
    style: {
      fill: "rgb(199, 210, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 380,
    r: 2.5,
    fill: "#C7D2FE",
    style: {
      fill: "rgb(199, 210, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 220,
    r: 2,
    fill: "#C7D2FE",
    style: {
      fill: "rgb(199, 210, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,90)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 190,
    height: 240,
    rx: 12,
    fill: "#FFFFFF",
    fillOpacity: 0.96,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#4338CA",
    style: {
      fill: "rgb(67, 56, 202)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 48,
    textAnchor: "middle",
    fontSize: 18,
    fontWeight: 500,
    fill: "#FFFFFF",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 18,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "in"), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 28,
    width: 100,
    height: 10,
    rx: 2,
    fill: "#1F2937",
    style: {
      fill: "rgb(31, 41, 55)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 44,
    width: 70,
    height: 7,
    rx: 2,
    fill: "#9CA3AF",
    style: {
      fill: "rgb(156, 163, 175)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 78,
    x2: 170,
    y2: 78,
    stroke: "#E5E7EB",
    strokeWidth: 1,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(229, 231, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 94,
    width: 150,
    height: 7,
    rx: 2,
    fill: "#D1D5DB",
    style: {
      fill: "rgb(209, 213, 219)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 108,
    width: 130,
    height: 7,
    rx: 2,
    fill: "#D1D5DB",
    style: {
      fill: "rgb(209, 213, 219)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 122,
    width: 140,
    height: 7,
    rx: 2,
    fill: "#D1D5DB",
    style: {
      fill: "rgb(209, 213, 219)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 136,
    width: 100,
    height: 7,
    rx: 2,
    fill: "#D1D5DB",
    style: {
      fill: "rgb(209, 213, 219)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 160,
    width: 60,
    height: 22,
    rx: 11,
    fill: "#E0E7FF",
    style: {
      fill: "rgb(224, 231, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 175,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#4338CA",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(67, 56, 202)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "React"), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 160,
    width: 60,
    height: 22,
    rx: 11,
    fill: "#E0E7FF",
    style: {
      fill: "rgb(224, 231, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 175,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#4338CA",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(67, 56, 202)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Node"), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 198,
    width: 150,
    height: 26,
    rx: 13,
    fill: "#0A66C2",
    style: {
      fill: "rgb(10, 102, 194)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 215,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#FFFFFF",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Postularme")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,165)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0 L8 50 L30 50 L18 100 L70 38 L42 38 L60 0 Z",
    fill: "#FDE68A",
    stroke: "#FBBF24",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    style: {
      fill: "rgb(253, 230, 138)",
      stroke: "rgb(251, 191, 36)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 195,
    x2: 278,
    y2: 195,
    stroke: "#E0E7FF",
    strokeWidth: 1.5,
    strokeDasharray: "2 5",
    opacity: 0.7,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(224, 231, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeDasharray: "2px, 5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392,
    y1: 200,
    x2: 422,
    y2: 200,
    stroke: "#E0E7FF",
    strokeWidth: 1.5,
    strokeDasharray: "2 5",
    opacity: 0.7,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(224, 231, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeDasharray: "2px, 5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(442,90)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 190,
    height: 240,
    rx: 12,
    fill: "#FFFFFF",
    fillOpacity: 0.96,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 150,
    height: 9,
    rx: 2,
    fill: "#1F2937",
    style: {
      fill: "rgb(31, 41, 55)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    width: 100,
    height: 7,
    rx: 2,
    fill: "#9CA3AF",
    style: {
      fill: "rgb(156, 163, 175)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 100,
    r: 34,
    fill: "none",
    stroke: "#E5E7EB",
    strokeWidth: 8,
    style: {
      fill: "none",
      stroke: "rgb(229, 231, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 100,
    r: 34,
    fill: "none",
    stroke: "#4338CA",
    strokeWidth: 8,
    strokeDasharray: "186 213",
    strokeLinecap: "round",
    transform: "rotate(-90 48 100)",
    style: {
      fill: "none",
      stroke: "rgb(67, 56, 202)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 8,
      strokeDasharray: "186px, 213px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 105,
    textAnchor: "middle",
    fontSize: 16,
    fontWeight: 600,
    fill: "#4338CA",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(67, 56, 202)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 16,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "87%"), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 80,
    width: 72,
    height: 20,
    rx: 10,
    fill: "#DCFCE7",
    style: {
      fill: "rgb(220, 252, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 94,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#166534",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(22, 101, 52)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "React"), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 104,
    width: 72,
    height: 20,
    rx: 10,
    fill: "#DCFCE7",
    style: {
      fill: "rgb(220, 252, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 118,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#166534",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(22, 101, 52)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Node.js"), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 148,
    x2: 170,
    y2: 148,
    stroke: "#E5E7EB",
    strokeWidth: 1,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(229, 231, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 168,
    fontSize: 11,
    fill: "#9CA3AF",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(156, 163, 175)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Salario estimado"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 188,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1F2937",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(31, 41, 55)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 17,
      fontWeight: 600,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "$3k - $4.5k"), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 202,
    width: 150,
    height: 24,
    rx: 12,
    fill: "#4338CA",
    style: {
      fill: "rgb(67, 56, 202)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 218,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#FFFFFF",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Generar CV")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,360)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 0,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 500,
    fill: "#FFFFFF",
    fontFamily: "Arial, sans-serif",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 22,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "ZeroLoop Job Hunter")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroloopPortfolioCoverV2);
export default __webpack_public_path__ + "static/media/zeroloop_portfolio_cover_v2.f59e821cffb3898a02f708186c391344.svg";
export { ForwardRef as ReactComponent };